import React from 'react';
import { Divider, Form, Radio } from '@roo/roo';
import { getLableByValue } from '@utils/positionTitle';
import {
 renderDetailByColumns, renderDetailListByColumns, defaultCols as cols, renderFileForPreview, renderEditor, renderFile, Area,
} from './util';

import '../index.scss';

const { Group: RadioGroup } = Radio;

const nominatorColumnsForJudge = [
  {
    label: '提名人',
    key: 'name',
  },
  {
    label: '提名人职务',
    key: 'position',
  },
  {
    label: '提名人工作单位',
    key: 'organization',
  },
  {
    label: '提名理由',
    key: 'nominationType',
    _render: (info, nominationType) => (info[nominationType] === 'file' ? renderFile(info, 'nominationUrl') : <span className="control-field">{String(info.nominationText || '')}</span>),
  },
];

const nominatorColumns = [
  {
    label: '提名码',
    key: 'code',
  },
  ...nominatorColumnsForJudge,
];

const recommendColumns = [{
  label: '推荐人姓名',
  key: 'name',
}, {
  label: '单位名称',
  key: 'company',
}, {
  label: '职务',
  key: 'job',
}, {
  label: '职称',
  key: 'positionalTitle',
  _render: (record) => {
    const { positionalTitle } = record;
    return <span className="control-field">{positionalTitle ? getLableByValue(positionalTitle) : ''}</span>;
  },
}, {
  label: '手机号',
  key: 'phone',
}, {
  label: '邮箱',
  key: 'email',
}, {
  label: '学科',
  key: 'studyArea',
  _render: (item) => {
    const {
      studyAreaType,
      studyAreaPath,
    } = item;
    return (
      <div>
        <RadioGroup value={studyAreaType}>
          <Radio value={1}>专一领域</Radio>
          <Radio value={2}>交叉领域</Radio>
        </RadioGroup>
        <div style={{ marginTop: '10px' }}>
          <Area value={studyAreaPath} />
        </div>
      </div>
    );
  },
}, {
  label: '主要研究方向',
  key: 'researchDirection',
}, {
  label: '推荐信',
  key: 'letterUrl',
  layout: 'vertical',
  _render: renderFileForPreview,
}];

const recommendColumnsForJudge = [
  {
    label: '推荐人姓名',
    key: 'name',
  },
  {
    label: '单位名称',
    key: 'company',
  },
  {
    label: '职称',
    key: 'positionalTitle',
    _render: (record) => {
      const { positionalTitle } = record;
      return <span className="control-field">{positionalTitle ? getLableByValue(positionalTitle) : ''}</span>;
    },
  },
  {
    label: '推荐信',
    key: 'letterUrl',
    layout: 'vertical',
    _render: renderFileForPreview,
  },
];

const researchOverviewColumns = [
  {
    label: '科研及学术成就介绍',
    key: 'achievement',
    layout: 'vertical',
    _render: renderEditor,
  },
  {
    label: '在研科研项目及学术进展',
    key: 'progress',
    layout: 'vertical',
    _render: renderEditor,
  },
  {
    label: '未来五年科研工作规划',
    key: 'futurePlan',
    layout: 'vertical',
    _render: renderEditor,
  },
  {
    label: '个人研究方向对相关议题研究的贡献和价值',
    key: 'contribution',
    layout: 'vertical',
    _render: renderEditor,
  },
];

const attachmentColumns = [
  {
    label: '附件',
    key: 'overviewFile',
    layout: 'vertical',
    _render: renderFile,
  },
];

export default ({ detail: applyInfo, isView = false }) => {
  const {
 recommendInfo, researchOverview, isNominated, nominationInfo, researchOverviewFileKeyMap,
} = applyInfo;

  window.GreenFileKey = researchOverviewFileKeyMap || {};

  return (
    <>
      <h3 id="nomination" className="catalogue-tag">
        是否提名
      </h3>
      <Divider />
      <div className="preview-item-wrap">
        <div className="preview-item-wrap-withoutbackground">
          <Form cols={cols}>
            <Form.Field label="是否提名" required className="preview-item-text">
              <div>
                <RadioGroup value={!!isNominated}>
                  <Radio value={false} disabled>
                    推荐申报
                  </Radio>
                  <Radio value disabled>
                    提名申报
                  </Radio>
                </RadioGroup>
              </div>
            </Form.Field>
          </Form>
        </div>
      </div>
      {isNominated ? (
        <>
          <div className="preview-label-wrap">
            <h3 id="recommend" className="catalogue-tag">
              提名信息
            </h3>
          </div>
          <Divider />
          {renderDetailListByColumns(nominationInfo, isView ? nominatorColumnsForJudge : nominatorColumns)}
        </>
      ) : (
        <>
          <div className="preview-label-wrap">
            <h3 id="recommend" className="catalogue-tag">
              推荐信息
            </h3>
            <span className="preview-tips">请上传2份以上的推荐信息</span>
          </div>
          <Divider />
          {renderDetailListByColumns(recommendInfo, isView ? recommendColumnsForJudge : recommendColumns)}
        </>
      )}
      <h3 id="researchOverview" className="catalogue-tag">
        个人科研成就、进展及规划
      </h3>
      <Divider />

      {researchOverview?.fillInType === 'uploadFile' ? renderDetailByColumns(researchOverview, attachmentColumns) : null}
      {researchOverview?.fillInType === 'onlineFillIn' ? renderDetailByColumns(researchOverview, researchOverviewColumns) : null}
    </>
  );
};
